import moment from 'moment';

export const addResultAction = (data) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(data.term);
      firestore
        .collection("students")
        .doc(data.id)
        .update({
            currentResultsTerm: data.term,
            resultsLink: data.uploadedFileUrl,
            crDate: moment().format('L')
        })
        .then(() => {
          dispatch({
            type: "ADD_RESULT",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_RESULT_ERR",
            err
          });
        });
    };
  };
  